"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var react_router_dom_1 = require("react-router-dom");
var LocalParking_1 = __importDefault(require("@mui/icons-material/LocalParking"));
var Home_1 = __importDefault(require("@mui/icons-material/Home"));
require("./styles/application.scss");
require("./styles/parking.scss");
function Home() {
    var navigate = (0, react_router_dom_1.useNavigate)();
    return (react_1.default.createElement("div", { className: "section flex-grow center" },
        react_1.default.createElement(material_1.Grid, { container: true, spacing: 5 },
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(material_1.Button, { variant: "contained", sx: {
                        backgroundColor: '#f37f30',
                        color: 'white',
                        marginBottom: '20px',
                    }, onClick: function () { return navigate('/login'); }, startIcon: react_1.default.createElement(Home_1.default, null), type: "submit" }, "Resident Login")),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(material_1.Button, { variant: "contained", onClick: function () { return navigate('/parking'); }, sx: {
                        backgroundColor: '#f37f30',
                        color: 'white',
                        marginBottom: '20px',
                    }, startIcon: react_1.default.createElement(LocalParking_1.default, null), type: "submit" }, "Visitor Parking Registration")))));
}
exports.default = Home;
